import { __ } from "@wordpress/i18n";
import type1 from "../assets/type1.png";
import type2 from "../assets/type2.png";
import type3 from "../assets/type3.png";
import type4 from "../assets/type4.png";
import type5 from "../assets/type5.png";
import type6 from "../assets/type6.png";
import type7 from "../assets/type7.png";

export const btnSkins = [
    {
        value: "type1",
        label: __("Type 1", "wpbean-quantity-controls-for-woocommerce"),
        image: type1,
    },
    {
        value: "type2",
        label: __("Type 2", "wpbean-quantity-controls-for-woocommerce"),
        image: type2,
    },
    {
        value: "type3",
        label: __("Type 3", "wpbean-quantity-controls-for-woocommerce"),
        image: type3,
    },
    {
        value: "type4",
        label: __("Type 4", "wpbean-quantity-controls-for-woocommerce"),
        image: type4,
    },
    {
        value: "type5",
        label: __("Type 5", "wpbean-quantity-controls-for-woocommerce"),
        image: type5,
    },
    {
        value: "type6",
        label: __("Type 6", "wpbean-quantity-controls-for-woocommerce"),
        image: type6,
    },
    {
        value: "type7",
        label: __("Type 7", "wpbean-quantity-controls-for-woocommerce"),
        image: type7,
    },
];
